import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CurrencyInput from 'react-currency-input-field';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { informacionCliente, editarCliente, limpiarCliente } from '../../actions/clientes';
import { buscarRegimenesFiscalesConfiguracion, buscarGirosConfiguracion } from '../../actions/configuracion';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const EditarCliente = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Clientes',
            path: '/clientes'
        },
        {
            activo: true,
            nombre: 'Editar cliente',
            path: '/clientes/editar'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const regimenes_fiscales = useSelector(state => state.configuracion.regimenes_fiscales);
    const giros = useSelector(state => state.configuracion.giros);

    const { id } = useParams();

    const { detalles } = useSelector(state => state.clientes);

    const [clienteData, setClienteData] = useState({
        id: null,
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        nacimiento: null,
        celular: null,
        email: null, 
        nombre_comercial: null, 
        razon_social: null, 
        rfc: null, 
        curp: null, 
        tipo_persona: null, 
        regimen_fiscal: null, 
        giro: null, 
        representante_legal: null, 
        puesto: null, 
        domicilio_fiscal: null, 
        telefono: null, 
        email_empresarial: null, 
        web: null, 
        fecha_constitucion: null, 
        numero_empleados: null, 
        minimo_ingresos_anuales: null, 
        maximo_ingresos_anuales: null
    });

    const [celularDialCode, setCelularDialCode] = useState('52');
    const [telefonoDialCode, setTelefonoDialCode] = useState('52');

    const [tipoPersonaData, setTipoPersonaData] = useState(null);
    const tiposPersonaFilter = [
        { value: 0, label: 'Física' }, 
        { value: 1, label: 'Moral' }
    ];

    const [regimenFiscalData, setRegimenFiscalData] = useState(null);
    const [regimenesFiscalesFilter, setRegimenesFiscalesFilter] = useState([]);

    const [giroData, setGiroData] = useState(null);
    const [girosFilter, setGirosFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    const validarRFC = (rfc, tipo_persona) => {
        const rfcLimpio = rfc.toUpperCase().replace(/[\s-]/g, '');
        if (!/^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/.test(rfcLimpio)) {
            return 'El RFC no tiene un formato válido.';
        }
        if (rfcLimpio === 'XAXX010101000') {
            return 'El RFC genérico no es válido.';
        }
        if (rfcLimpio.length === 12 && tipo_persona === 0) {
            return 'El RFC no corresponde al tipo de persona seleccionado.';
        }
        if (rfcLimpio.length === 13 && tipo_persona === 1) {
            return 'El RFC no corresponde al tipo de persona seleccionado.';
        }
        const dateStart = rfcLimpio.length === 12 ? 3 : 4;
        const mes = parseInt(rfcLimpio.substring(dateStart + 2, dateStart + 4), 10);
        const dia = parseInt(rfcLimpio.substring(dateStart + 4, dateStart + 6), 10);
        if (mes < 1 || mes > 12 || dia < 1 || dia > 31) {
            return 'La fecha en el RFC no es válida.';
        }
        return null;
    };

    /* Editar cliente */
    const handleInputChange = ({ target }) => {
        setClienteData({
            ...clienteData,
            [target.name]: target.value
        });
    }

    const handleRfcChange = ({ target }) => {
        setClienteData({
            ...clienteData,
            rfc: target.value.toUpperCase().replace(/[\s-]/g, '')
        });
    }

    const handleNumberChange = (value, name) => {
        setClienteData({
            ...clienteData,
            [name]: value || ''
        });
    }

    const handleDatePicker = (name, value) => {
        setClienteData({
            ...clienteData,
            [name]: value
        });
    }

    const handleSelectTipoPersona = (option) => {
        setTipoPersonaData(option);
        setRegimenFiscalData(null);

        setClienteData({
            ...clienteData,
            tipo_persona: option != null ? option.value : null, 
            regimen_fiscal: null
        });

        dispatch(buscarRegimenesFiscalesConfiguracion(option?.value));
    }

    const handleSelectRegimenFiscal = (option) => {
        setRegimenFiscalData(option);

        setClienteData({
            ...clienteData,
            regimen_fiscal: option != null ? option.value : null
        });
    }

    const handleSelectGiro = (option) => {
        setGiroData(option);

        setClienteData({
            ...clienteData,
            giro: option != null ? option.value : null
        });
    }

    const handleEditarCliente = async () => {
        if (!clienteData.nombre) {
            await dispatch(setAlert('El nombre es obligatorio.', 'danger'));
            return;
        }
        if (clienteData.celular && (clienteData.celular.length - celularDialCode.length) !== 10) {
            await dispatch(setAlert('El teléfono debe tener 10 dígitos sin contar la lada.', 'danger'));
            return;
        }
        if (clienteData.telefono && (clienteData.telefono.length - telefonoDialCode.length) !== 10) {
            await dispatch(setAlert('El teléfono empresarial debe tener 10 dígitos sin contar la lada.', 'danger'));
            return;
        }
        if (clienteData.rfc) {
            if (clienteData.tipo_persona === null || clienteData.tipo_persona === undefined) {
                await dispatch(setAlert('Selecciona el tipo de persona para validar el RFC.', 'danger'));
                return;
            }
            const errorRfc = validarRFC(clienteData.rfc, clienteData.tipo_persona);
            if (errorRfc) {
                await dispatch(setAlert(errorRfc, 'danger'));
                return;
            }
        }
        if (clienteData.tipo_persona === 1) {
            if (!clienteData.razon_social) {
                await dispatch(setAlert('La razón social es obligatoria para personas morales.', 'danger'));
                return;
            }
            if (!clienteData.regimen_fiscal) {
                await dispatch(setAlert('El régimen fiscal es obligatorio para personas morales.', 'danger'));
                return;
            }
        }
        await dispatch(editarCliente(clienteData));
        await navigate("/clientes");
    }

    useEffect(() => {
        dispatch(limpiarCliente());
        dispatch(buscarGirosConfiguracion());

        return () => {
            dispatch(limpiarCliente());
        }
    }, []);

    useEffect(() => {
        dispatch(informacionCliente(id));

        if(id){
            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < regimenes_fiscales.listado?.length; i++) {
            options.push({ value: regimenes_fiscales.listado[i]._id, label: regimenes_fiscales.listado[i].nombre });
        }

        if(options.length > 0){
            let regimen_fiscal_asignado = options.find( regimen => String(regimen.value) === String(detalles?.regimen_fiscal) );

            if(regimen_fiscal_asignado){
                setRegimenFiscalData({value: regimen_fiscal_asignado.value, label: regimen_fiscal_asignado.label});
            }
        }

        setRegimenesFiscalesFilter(options);
    }, [regimenes_fiscales]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < giros.listado?.length; i++) {
            options.push({ value: giros.listado[i]._id, label: giros.listado[i].nombre });
        }

        setGirosFilter(options);
    }, [giros]);

    useEffect(() => {
        setClienteData({
            ...clienteData,
            id: detalles?._id,
            nombre: detalles?.nombre,
            apellido_paterno: detalles?.apellido_paterno,
            apellido_materno: detalles?.apellido_materno,
            nacimiento: detalles?.nacimiento,
            celular: detalles?.celular,
            email: detalles?.email, 
            nombre_comercial: detalles?.nombre_comercial, 
            razon_social: detalles?.razon_social, 
            rfc: detalles?.rfc, 
            curp: detalles?.curp, 
            tipo_persona: detalles?.tipo_persona, 
            regimen_fiscal: detalles?.regimen_fiscal, 
            giro: detalles?.giro, 
            representante_legal: detalles?.representante_legal, 
            puesto: detalles?.puesto, 
            domicilio_fiscal: detalles?.domicilio_fiscal, 
            telefono: detalles?.telefono, 
            email_empresarial: detalles?.email_empresarial, 
            web: detalles?.web, 
            fecha_constitucion: detalles?.fecha_constitucion, 
            numero_empleados: detalles?.numero_empleados, 
            minimo_ingresos_anuales: detalles?.minimo_ingresos_anuales, 
            maximo_ingresos_anuales: detalles?.maximo_ingresos_anuales
        });

        if(tiposPersonaFilter.length > 0){
            let tipo_persona_asignado = tiposPersonaFilter.find( tipo => tipo.value == detalles?.tipo_persona );

            if(tipo_persona_asignado){
                setTipoPersonaData({value: tipo_persona_asignado.value, label: tipo_persona_asignado.label});

                dispatch(buscarRegimenesFiscalesConfiguracion(detalles?.tipo_persona));

                if(regimenesFiscalesFilter.length > 0){
                    let regimen_fiscal_asignado = regimenesFiscalesFilter.find( regimen => String(regimen.value) === String(detalles?.regimen_fiscal) );

                    if(regimen_fiscal_asignado){
                        setRegimenFiscalData({value: regimen_fiscal_asignado.value, label: regimen_fiscal_asignado.label});
                    }
                }
            }
        }

        if(girosFilter.length > 0){
            let giro_asignado = girosFilter.find( giro => String(giro.value) === String(detalles?.giro) );

            if(giro_asignado){
                setGiroData({value: giro_asignado.value, label: giro_asignado.label});
            }
        }
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Editar cliente</h3>
                
                    <div className="row">
                        <div className="col-md-12">
                            <div className="accordion" id="accordionNuevo">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Información personal
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={clienteData.nombre} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="nombre">Nombre</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={clienteData.apellido_paterno} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="apellido_paterno">Apellido paterno</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={clienteData.apellido_materno} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="apellido_materno">Apellido materno</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <DatePicker
                                                            id="nacimiento"
                                                            name="nacimiento"
                                                            className="form-control text-center input-datepícker"
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="es-ES"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={ clienteData.nacimiento != null ? new Date(clienteData.nacimiento) : '' }
                                                            onChange={ date => handleDatePicker('nacimiento', date) }
                                                        />
                                                        <label className="label-datepicker" htmlFor="nacimiento">Fecha de nacimiento</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-3 form-group mb-3">
                                                <PhoneInput
                                                    country="mx"
                                                    preferredCountries={['mx', 'us']}
                                                    enableSearch={true}
                                                    placeholder="Teléfono"
                                                    value={clienteData.celular || ''}
                                                    onChange={(value, countryData) => { setClienteData({ ...clienteData, celular: value }); setCelularDialCode(countryData.dialCode); }}
                                                    inputClass="form-control"
                                                    containerClass="w-100"
                                                    inputStyle={{ width: '100%', height: 'calc(3.5rem + 2px)' }}
                                                    buttonStyle={{ height: 'calc(3.5rem + 2px)' }}
                                                />
                                            </div>

                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Correo" id="email" name="email" value={clienteData.email} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="email">Correo</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                            Información empresarial
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Nombre comercial" id="nombre_comercial" name="nombre_comercial" value={clienteData.nombre_comercial} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="nombre_comercial">Nombre comercial</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Razón social" id="razon_social" name="razon_social" value={clienteData.razon_social} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="razon_social">Razón social</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="RFC" id="rfc" name="rfc" value={clienteData.rfc || ''} onChange={e => handleRfcChange(e)}/>
                                                        <label htmlFor="rfc">RFC</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="CURP" id="curp" name="curp" value={clienteData.curp} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="curp">CURP</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group h-100">
                                                    <Select
                                                        id="tipo_persona"
                                                        name="tipo_persona"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Tipo de persona"
                                                        isClearable={true}
                                                        options={tiposPersonaFilter}
                                                        value={tipoPersonaData}
                                                        onChange={(value) => handleSelectTipoPersona(value)}
                                                        menuPortalTarget={document.body}
                                                        components={{ ValueContainer: CustomValueContainer }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-5 form-group mb-3">
                                                <div className="input-group h-100">
                                                    <Select
                                                        id="regimen_fiscal"
                                                        name="regimen_fiscal"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Régimen fiscal"
                                                        isClearable={true}
                                                        options={regimenesFiscalesFilter}
                                                        value={regimenFiscalData}
                                                        onChange={(value) => handleSelectRegimenFiscal(value)}
                                                        menuPortalTarget={document.body}
                                                        components={{ ValueContainer: CustomValueContainer }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 form-group mb-3">
                                                <div className="input-group h-100">
                                                    <Select
                                                        id="giro"
                                                        name="giro"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Actividad empresarial"
                                                        isClearable={true}
                                                        options={girosFilter}
                                                        value={giroData}
                                                        onChange={(value) => handleSelectGiro(value)}
                                                        menuPortalTarget={document.body}
                                                        components={{ ValueContainer: CustomValueContainer }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                            </div>
                                            
                                            <hr />
                                            
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Representante legal" id="representante_legal" name="representante_legal" value={clienteData.representante_legal} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="representante_legal">Representante legal</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Puesto" id="puesto" name="puesto" value={clienteData.puesto} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="puesto">Puesto</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Domicilio fiscal" id="domicilio_fiscal" name="domicilio_fiscal" value={clienteData.domicilio_fiscal} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="domicilio_fiscal">Domicilio fiscal</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <PhoneInput
                                                    country="mx"
                                                    preferredCountries={['mx', 'us']}
                                                    enableSearch={true}
                                                    placeholder="Teléfono empresarial"
                                                    value={clienteData.telefono || ''}
                                                    onChange={(value, countryData) => { setClienteData({ ...clienteData, telefono: value }); setTelefonoDialCode(countryData.dialCode); }}
                                                    inputClass="form-control"
                                                    containerClass="w-100"
                                                    inputStyle={{ width: '100%', height: 'calc(3.5rem + 2px)' }}
                                                    buttonStyle={{ height: 'calc(3.5rem + 2px)' }}
                                                />
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Correo" id="email_empresarial" name="email_empresarial" value={clienteData.email_empresarial} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="email_empresarial">Correo</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" placeholder="Sitio web" id="web" name="web" value={clienteData.web} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="web">Sitio web</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <DatePicker
                                                            id="fecha_constitucion"
                                                            name="fecha_constitucion"
                                                            className="form-control text-center input-datepícker"
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="es-ES"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={ clienteData.fecha_constitucion != null ? new Date(clienteData.fecha_constitucion) : '' }
                                                            onChange={ date => handleDatePicker('fecha_constitucion', date) }
                                                        />
                                                        <label className="label-datepicker" htmlFor="fecha_constitucion">Fecha de constitución</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <input type="number" className="form-control" placeholder="Número de empleados" id="numero_empleados" name="numero_empleados" value={clienteData.numero_empleados} onChange={e => handleInputChange(e)}/>
                                                        <label htmlFor="numero_empleados">Número de empleados</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <CurrencyInput
                                                            id="minimo_ingresos_anuales"
                                                            name="minimo_ingresos_anuales"
                                                            className="form-control text-center"
                                                            value={clienteData.minimo_ingresos_anuales || ''}
                                                            decimalsLimit={2}
                                                            groupSeparator=","
                                                            decimalSeparator="."
                                                            onValueChange={(value) => handleNumberChange(value, 'minimo_ingresos_anuales')}
                                                        />
                                                        <label htmlFor="minimo_ingresos_anuales">Mínimo de ingresos anuales</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 form-group mb-3">
                                                <div className="input-group">
                                                    <div className="form-floating">
                                                        <CurrencyInput
                                                            id="maximo_ingresos_anuales"
                                                            name="maximo_ingresos_anuales"
                                                            className="form-control text-center"
                                                            value={clienteData.maximo_ingresos_anuales || ''}
                                                            decimalsLimit={2}
                                                            groupSeparator=","
                                                            decimalSeparator="."
                                                            onValueChange={(value) => handleNumberChange(value, 'maximo_ingresos_anuales')}
                                                        />
                                                        <label htmlFor="maximo_ingresos_anuales">Máximo de ingresos anuales</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleEditarCliente}>Guardar</button>
                            <Link to='/clientes'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EditarCliente;